var _defs, _path, _g, _path2, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: #9fa4a6;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 41.9418,
    y1: 304.779,
    x2: 310.4427,
    y2: 36.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f17067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 66.6098,
    y1: 329.4469,
    x2: 335.1107,
    y2: 60.946,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 154.5042,
    y1: 417.3413,
    x2: 423.0051,
    y2: 148.8404,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.2051,321.5941h-10.1932v-113.7834h34.4897c24.3463,0,44.1525-19.8028,44.1525-44.1445,0-19.5415-13.065-36.9713-31.7729-42.3857l-5.7232-1.6559,2.5223-5.3975c3.6013-7.7026,5.4269-15.9164,5.4269-24.4119,0-31.9459-25.9897-57.9357-57.9368-57.9357-8.8223,0-17.6967,2.0913-25.6629,6.0501l-3.2586,1.6186-2.589-2.5551c-12.8094-12.6408-30.4043-19.891-48.2752-19.891-37.9169,0-68.7634,30.8488-68.7634,68.7668,0,3.0516.2194,6.1632.6515,9.2476l.673,4.7991-4.7595.9139c-25.4027,4.8749-43.8403,27.1581-43.8403,52.985,0,29.7732,24.2219,53.9962,53.9962,53.9962h38.0187l.0011,62.374h-10.1932l-.0011-52.1808h-27.8255c-35.3935,0-64.1894-28.7948-64.1894-64.1894,0-29.1251,19.7191-54.4599,47.5163-61.9374-.1595-2.011-.2409-4.0198-.2409-6.0082,0-43.5383,35.4206-78.96,78.9566-78.96,19.6456,0,38.2743,7.2117,52.8436,20.3819,8.5-3.6737,17.7431-5.6045,26.9421-5.6045,37.5662,0,68.13,30.5626,68.13,68.1289,0,8.1154-1.4161,16.0114-4.2144,23.5444,20.1308,8.2353,33.7613,28.1716,33.7613,50.3066,0,29.9609-24.378,54.3377-54.3411,54.3377h-24.301v103.5902Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "168.3007 301.4768 158.1075 301.4768 158.1075 184.8748 134.1865 160.9538 134.1865 110.7863 144.3797 110.7863 144.3797 156.7327 168.3007 180.6537 168.3007 301.4768"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.2831,114.1965c-8.3032,0-15.0579-6.7548-15.0579-15.0579s6.7548-15.0579,15.0579-15.0579,15.0579,6.7548,15.0579,15.0579-6.7548,15.0579-15.0579,15.0579ZM139.2831,94.2738c-2.6829,0-4.8647,2.1818-4.8647,4.8647s2.1818,4.8647,4.8647,4.8647,4.8647-2.1818,4.8647-4.8647-2.1818-4.8647-4.8647-4.8647Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.2041,323.1685c-8.3032,0-15.0579-6.7548-15.0579-15.0568s6.7548-15.0591,15.0579-15.0591,15.0579,6.7548,15.0579,15.0591-6.7548,15.0568-15.0579,15.0568ZM163.2041,303.2458c-2.6829,0-4.8647,2.183-4.8647,4.8659s2.1818,4.8636,4.8647,4.8636,4.8647-2.1807,4.8647-4.8636-2.1818-4.8659-4.8647-4.8659Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.3604,291.7542c-8.3032,0-15.0579-6.7548-15.0579-15.0568s6.7548-15.0591,15.0579-15.0591,15.0579,6.7548,15.0579,15.0591-6.7548,15.0568-15.0579,15.0568ZM119.3604,271.8315c-2.6829,0-4.8647,2.183-4.8647,4.8659s2.1818,4.8636,4.8647,4.8636,4.8647-2.1807,4.8647-4.8636-2.1818-4.8659-4.8647-4.8659Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 201.2431,
    y: 128.854,
    width: 10.1932,
    height: 119.5847
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.3397,138.2001c-8.3032,0-15.0579-6.7548-15.0579-15.0579s6.7548-15.0579,15.0579-15.0579,15.0579,6.7548,15.0579,15.0579-6.7548,15.0579-15.0579,15.0579ZM206.3397,118.2774c-2.6829,0-4.8647,2.1818-4.8647,4.8647s2.1818,4.8647,4.8647,4.8647,4.8647-2.1818,4.8647-4.8647-2.1818-4.8647-4.8647-4.8647Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.3397,271.3383c-8.3032,0-15.0579-6.7548-15.0579-15.0591s6.7548-15.0568,15.0579-15.0568,15.0579,6.7548,15.0579,15.0568-6.7548,15.0591-15.0579,15.0591ZM206.3397,251.4157c-2.6829,0-4.8647,2.1807-4.8647,4.8636s2.1818,4.8659,4.8647,4.8659,4.8647-2.183,4.8647-4.8659-2.1818-4.8636-4.8647-4.8636Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.8121,343.0912c-8.3032,0-15.0579-6.7548-15.0579-15.0568s6.7548-15.0591,15.0579-15.0591,15.0579,6.7548,15.0579,15.0591-6.7548,15.0568-15.0579,15.0568ZM243.8121,323.1685c-2.6829,0-4.8647,2.183-4.8647,4.8659s2.1818,4.8636,4.8647,4.8636,4.8647-2.1807,4.8647-4.8636-2.1818-4.8659-4.8647-4.8659Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaas);
export default __webpack_public_path__ + "static/media/saas.3bd2a3ef77744101185b80ea24b724ad.svg";
export { ForwardRef as ReactComponent };